import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Ban, LogOut } from "lucide-react";
import { isAuthed, financeApi, logout } from "../lib/api";

export default function Suspendido() {
  const navigate = useNavigate();
  const [reason, setReason] = useState("");
  const [checked, setChecked] = useState(false);
  const [active, setActive] = useState(true);

  useEffect(() => {
    if (!isAuthed()) return;
    financeApi.status().then((s) => {
      if (!s.suspendido_manual) { setActive(false); }
      setReason(s.manual_reason || "");
    }).catch(() => {}).finally(() => setChecked(true));
  }, []);

  if (!isAuthed()) return <Navigate to="/login" replace />;
  if (checked && !active) return <Navigate to="/mi-cuenta" replace />;

  const salir = () => { logout(); navigate("/login", { replace: true }); };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-6" data-testid="suspendido-page">
      <div className="max-w-md w-full bg-white rounded-3xl p-8 text-center ring-1 ring-black/5">
        <span className="mx-auto w-16 h-16 rounded-2xl bg-[#F1E9F7] flex items-center justify-center"><Ban className="w-9 h-9 text-[#8E44AD]" /></span>
        <h1 className="mt-5 text-2xl font-extrabold text-[#0A1C30]">Cuenta suspendida temporalmente</h1>
        <p className="mt-3 text-[#4A5568] text-sm leading-relaxed" data-testid="suspendido-reason">
          {reason || "Tu acceso ha sido suspendido temporalmente por el equipo de Supera. Por favor contacta al Staff para más información."}
        </p>
        <button data-testid="suspendido-logout" onClick={salir} className="mt-6 inline-flex items-center gap-2 rounded-xl bg-[var(--gold)] text-[#0A1C30] font-extrabold px-6 py-3">
          <LogOut className="w-4 h-4" /> Cerrar sesión
        </button>
      </div>
    </div>
  );
}
